import React from "react";
import { Flame, Zap, Leaf, Mountain } from "lucide-react";

const CFG = {
  small: { bg: "bg-amber-100 text-amber-900 border-amber-200", Icon: Flame, label: "SMALL", upside: "EXPLOSIVE" },
  mid:   { bg: "bg-orange-100 text-orange-900 border-orange-200", Icon: Zap, label: "MID", upside: "HIGH" },
  large: { bg: "bg-blue-100 text-blue-900 border-blue-200", Icon: Mountain, label: "LARGE", upside: "MODERATE" },
  mega:  { bg: "bg-neutral-100 text-neutral-700 border-neutral-200", Icon: Leaf, label: "MEGA", upside: "INCREMENTAL" },
};

export default function TierBadge({ tier, upside, className = "" }) {
  const c = CFG[tier] || CFG.large;
  return (
    <span
      className={`inline-flex items-center gap-1 ${c.bg} border px-2 py-0.5 rounded-full text-[10px] font-bold font-mono-data tracking-wider ${className}`}
      data-testid={`tier-badge-${tier}`}
      title={`${c.label} cap · ${upside || c.upside} upside`}
    >
      <c.Icon className="w-3 h-3" />
      {c.label}
    </span>
  );
}
